document.addEventListener('DOMContentLoaded', async () => {
  const blocks = document.querySelectorAll('.product-block-auto');
  if (!blocks.length) return;

  const moneyFormat = (yen) => `¥${Number(yen).toLocaleString('ja-JP')}`;

  for (const block of blocks) {
    const handle = block.dataset.productHandle;
    if (!handle) continue;

    try {
      const res = await fetch(window.Shopify.routes.root + `products/${handle}.js`);
      if (!res.ok) throw new Error(`Failed: ${handle}`);

      const product = await res.json();

      const image = product.images?.[0] || '';
      const url = `${window.Shopify.routes.root}products/${product.handle}`;
      const price = moneyFormat(product.price / 100);

      const brandName = product.vendor ? `【${product.vendor}】` : '';
      const collectionName = product.type ? `(${product.type})` : '';
      const productTitle = product.title || '';

      const displayTitle = brandName
      ? `<span class="pb-brand">${brandName}</span>
       <span class="pb-name">${collectionName} ${productTitle}</span>`
      : `<span class="pb-name">${collectionName} ${productTitle}</span>`;

      block.innerHTML = `
        <div class="thumbnail">
          <div style="background-image:url('${image}')"></div>
        </div>
        <div class="info">
          <div class="title">${displayTitle}</div>
          <div class="bottom">
            <div class="price">${price}<span>（税込）</span></div>
            <a class="link" href="${url}">
              <span>詳しく見る</span>
            </a>
          </div>
        </div>
      `;
    } catch (e) {
      console.error(e);
    }
  }
});